var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.barChart2Info.nodeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }